module.exports = __webpack_public_path__ + "static/media/settings-gear_1.12183cc6.svg";